const shakerCaseFormatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      '$1' + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  var result = format.replace(placeholderRegex, value);

  // The format template (_TC.moneyFormat) is a static string pulled from
  // the shop's DEFAULT currency (e.g. "${{amount}}"), with no awareness of
  // which currency is actually active. The underlying amount is already
  // correctly localized upstream, but the symbol/prefix isn't — so AUD,
  // CAD, etc. all silently show a bare "$", indistinguishable from USD.
  // This appends the correct currency prefix (matching the same visual
  // style used elsewhere on the site, e.g. "A$", "CA$") whenever the active
  // currency isn't USD.
  try {
    var active = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    if (active !== 'USD' && result.indexOf('$') !== -1) {
      var parts = new Intl.NumberFormat(undefined, { style: 'currency', currency: active }).formatToParts(0);
      var symbolPart = parts.find(function (p) { return p.type === 'currency'; });
      if (symbolPart && symbolPart.value) {
        result = result.replace('$', symbolPart.value);
      }
    }
  } catch (e) {
    // If Intl lookup fails for any reason, fall back to the unmodified
    // (USD-style) format rather than breaking price display entirely.
  }

  return result;
};

window.addEventListener('DOMContentLoaded', () => {
	const body = document.querySelector('body');
	const form = document.querySelector('.tcustomizer-customization-form');

  function toggleAddons() {
    form.classList.toggle('show-all-addons');

    const helper = form.querySelector('.helper-show-addons');
    const helperText = helper.innerText.toLowerCase();

    if (form.classList.contains('show-all-addons') && helperText.includes('more')) {
      helper.innerHTML = helper.innerHTML.replace('More', 'Less');
    } else if (!form.classList.contains('show-all-addons') && helperText.includes('less')) {
      helper.innerHTML = helper.innerHTML.replace('Less', 'More');
    }
  }

	// Image Slider
	function initSlider() {
		document.querySelectorAll('.custom-bigger-image-swatch').forEach((swatchGallery) => {
			if (!body.classList.contains('tcustomizer-product-7637079359574') || swatchGallery.classList.contains('is-carousel')) {
				return;
			}

			swatchGallery.classList.add('is-carousel');

			const mainRow = swatchGallery.querySelector('.tcustomizer-field__input .tcustomizer-row');
			const children = Array.from(mainRow.children);
			const groupSize = 8;

			const carousel = document.createElement('div');
			carousel.className = 'tcustomizer-carousel';

			const carouselInner = document.createElement('div');
			carouselInner.className = 'tcustomizer-carousel-inner';

			mainRow.innerHTML = '';
			mainRow.appendChild(carousel);
			carousel.appendChild(carouselInner);

			for (let i = 0; i < children.length; i += groupSize) {
				const slide = document.createElement('div');
				slide.className = 'tcustomizer-slide';

				const chunk = children.slice(i, i + groupSize);
				chunk.forEach(child => slide.appendChild(child));

				carouselInner.appendChild(slide);
			}

			const prevBtn = document.createElement('button');
			prevBtn.className = 'tcustomizer-prev';
			prevBtn.innerHTML = `
			  <svg viewBox="0 0 24 24">
			    <polyline points="15 4 7 12 15 20" />
			  </svg>
			`;

			const nextBtn = document.createElement('button');
			nextBtn.className = 'tcustomizer-next';
			nextBtn.innerHTML = `
			  <svg viewBox="0 0 24 24">
			    <polyline points="9 4 17 12 9 20" />
			  </svg>
			`;

			mainRow.appendChild(prevBtn);
			mainRow.appendChild(nextBtn);

			let currentIndex = 0;
			const totalSlides = carouselInner.children.length;

			function updateCarousel() {
				carouselInner.style.transform = `translateX(-${currentIndex * 100}%)`;
			}

			prevBtn.addEventListener('click', () => {
				currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
				updateCarousel();
			});

			nextBtn.addEventListener('click', () => {
				currentIndex = (currentIndex + 1) % totalSlides;
				updateCarousel();
			});
		});
	}
	initSlider();

	// Upload Kit
	function customizeUploadKit() {
		document.querySelectorAll('.uploadkit').forEach((uploadKit) => {
			document.querySelectorAll('[id^="tcustomizer-field-516460-"]').forEach((field) => {
				uploadKit.classList.add('is-hidden');

				field.querySelectorAll('.is-checked').forEach((checked) => {
					const input = checked.querySelector('input');
					if (input && input.value === 'Case + Layer + Charms') {
						uploadKit.classList.remove('is-hidden');
					}
				});
			});
		});
	}

	// Icons
	function customizeIcons() {
		form.querySelectorAll('.tcustomizer__description').forEach((element, index) => {
			const p = element.querySelector('p');

			if (p && !p.classList.contains('is-custom')) {
				p.classList.add('is-custom');

				if (index === 0) {
					p.innerHTML = '<img style="vertical-align: -6px;" src="//shakercase.com/cdn/shop/files/arrow_right_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg?v=1720942395" />' + p.innerHTML;
					p.style.cursor = 'pointer';

					p.addEventListener('click', () => {
						form.classList.toggle('show-all');

						const span = p.querySelector('span');

						if (span) {
							if (span.innerText.toLowerCase().includes('less')) {
								span.innerText = span.getAttribute('data-original-text');
							} else {
								span.setAttribute('data-original-text', span.innerText);
								span.innerText = 'Show Less';
							}
						}
					});

					if (document.querySelector('.tcustomizer-product-7406100021334')) {
						p.click();
					}
				} else {
					p.innerHTML = '<span class="material-icon material-symbols-outlined" style="font-size: 19px; vertical-align: -4px;">check_circle</span> ' + p.innerHTML;
				}
			}
		});
	}

	// Toggle
	function customizeToggles() {
		form.querySelectorAll('.more-line').forEach((element) => {
			const moreLineText = element.innerText.replace('?', '').toLowerCase().replace('check_circle', '').replace('more', '').replace('less', '').trim().replace(/[\s?]+/g, '-');
			element.classList.add(`helper-${moreLineText}`);
			
			if (moreLineText === 'show-addons') {
				form.classList.add('shorten-addons');

				element.removeEventListener('click', toggleAddons);
				element.addEventListener('click', toggleAddons);
			}
		});

		form.querySelectorAll('.tcustomizer-field--Toggle').forEach((element, index) => {
			const label = element.querySelector('.tcustomizer-toggle__label');

			element.classList.add(`sc-toggle`);
			element.classList.add(`sc-toggle-${index}`);

			element.addEventListener('click', () => {
				setTimeout(() => {
					initSlider();
				});
			});

			if (label) {
				const labelText = label.innerText.toLowerCase();

				if (labelText.includes('holographic') || labelText.includes('scratch')) {
					element.classList.add('has-holographic-icon');
				} else if (labelText.includes('personalize')) {
					element.classList.add('has-personalize-icon');
				} else if (labelText.includes('extra charms')) {
					element.classList.add('has-extra-charms-icon');
				} else if (labelText.includes('case designs')) {
					element.classList.add('has-case-designs-icon');
				} else if (labelText.includes('popular charms')) {
					element.classList.add('has-popular-charms-icon');
				} else if (labelText.includes('+ text charms')) {
					element.classList.add('has-plus-text-charms-icon');
				} else if (labelText.includes('+ letter charms')) {
					element.classList.add('has-letter-charms-icon');
				} else if (labelText.includes('magsafe')) {
					element.classList.add('has-magsafe-icon');
				}
			}
		});
	}

	customizeIcons();
	customizeToggles();

	setTimeout(() => {
		customizeUploadKit();
	}, 1000);

	form.addEventListener('click', () => {
		customizeIcons();
		customizeUploadKit();
		customizeToggles();

		setTimeout(() => {
		customizeUploadKit();
	}, 500);
	});	

	const convertPrice = (price) => {
		// return window.priceFormat.replace('0', (price / 100).toFixed(2));

		if (Shopify.currency.active !== 'USD') {
			price = Math.round(price / 100) * 100;
		}

		return shakerCaseFormatMoney(price, _TC.moneyFormat);
		// return window.formatMoney(price, _TC.moneyFormat);
	}

	// Labels
	const reStyleLabels = () => {
		const labels = form.querySelectorAll('.tcustomizer-field__heading');
		form.querySelectorAll('.quantity-breaks__title').forEach((title) => {
			title.remove();
		});

		labels.forEach((label) => {
			if (
				(
					label.innerText.includes(' Size') 
					&& !label.innerText.includes('Choose Charm Size')
				) 
				|| label.innerText.includes('Model:')) {
				return;
			}

			const span = label.querySelector('span');
			const tooltip = label.querySelector('.tcustomizer-tooltip');

			if (!span) {
				return;
			}

			const h3 = document.createElement('h3');
			h3.className = `quantity-breaks__title flex-center ${span.innerText.toLowerCase().includes('get 2 free') ? 'is-styled' : ''}`;

			const newTooltip = tooltip ? `<div class="tcustomizer-tooltip tcustomizer-tooltip__icon">
				<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
					<path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm2-13c0 .28-.21.8-.42 1L10 9.58c-.57.58-1 1.6-1 2.42v1h2v-1c0-.29.21-.8.42-1L13 9.42c.57-.58 1-1.6 1-2.42a4 4 0 1 0-8 0h2a2 2 0 1 1 4 0zm-3 8v2h2v-2H9z"></path>
				</svg>
				<div class="tcustomizer-tooltip--content tcustomizer-tooltip--content-top" style="left: 50%;">
					<div class="tooltip-text new-tooltip-text">${tooltip.querySelector('.tooltip-text').innerText}</div>
				</div>
				<div class="tcustomizer-tooltip--arrow tcustomizer-tooltip--arrow-top"></div>
			</div>` : '';

			h3.innerHTML = `<span></span><span class="mid-span">${span.innerText.trim()}${newTooltip}</span><span></span>`;

			label.after(h3);
			label.classList.add('is-hidden');
		});
	}
	reStyleLabels();

	form.addEventListener("click", function(event) {
		if (event.target.classList.contains('tcustomizer-toggle__input') || event.target.classList.contains('tcustomizer-radio__input')) {
			setTimeout(() => {
				reStyleLabels();
			});
		}

		if (event.target.classList.contains('tcustomizer__btn-check') || event.target.classList.contains('tcustomizer-radio__input')) {
			setTimeout(() => {
				initSlider();
			});
		}
	});

	// Radio
	const reStyleRadioElement = () => {
		form.querySelectorAll('.price-info').forEach((info) => {
			info.remove();
		});

		const radioControl = form.querySelector('.tcustomizer-field--Radio');

		if (!radioControl) {
			return;
		}

		const radioControlElements = radioControl.querySelectorAll('.tcustomizer-radio');
		radioControl.classList.add('quantity-breaks');
		radioControl.classList.add('quantity-breaks--compact');
		radioControl.classList.add('accent-color-outline-button');
		radioControl.querySelector('.tcustomizer-field__input .tcustomizer-vertical-row').classList.add('quantity-breaks-container');

		const evaluateCheckedRadio = () => {
			radioControlElements.forEach((element) => {
				const input = element.querySelector('input');

				element.classList.remove('is-checked');

				if (input.checked) {
					element.classList.add('is-checked');

					const priceInfo = element.querySelector('.price-info');
					form.querySelectorAll('.size-selectors').forEach((selector) => {
						selector.remove();
					});

					if (priceInfo) {
						const labelValue = element.querySelector('.tcustomizer-radio__label-value').innerText.split(' ')[0];
						let sizeSelectorsElements = '';
						let sizeSelectorsElementsCount = 0;

						for (let i=0; i<labelValue; i++) {
							sizeSelectorsElementsCount++;
							sizeSelectorsElements += `<div class="quantity-break__selector-item">
								<span class="quantity-break__selector-item__number">#${i+1}</span>
								<div class="select select--small no-background color-background-1 accent-color-accent-1 accent-2-color-text">
									<select class="quantity-break__variant-select select__select variant-dropdown" data-index="${i}"></select>
									<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
										<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
									</svg>
								</div>
							</div>`;
						}

						const sizeSelectors = document.createElement('div');
						sizeSelectors.addEventListener('click', (event) => {
							event.stopPropagation();
							event.preventDefault();
						});
						sizeSelectors.classList.add('size-selectors');
						sizeSelectors.classList.add(`size-selectors-${sizeSelectorsElementsCount}`);
						sizeSelectors.innerHTML = `<div class="quantity-break__variants">
							<span class="quantity-break__variants__label">Charm Sizes:</span>
							${sizeSelectorsElements}
						</div>`;

						priceInfo.after(sizeSelectors);

						sizeSelectors.querySelectorAll('select').forEach((select) => {
							select.addEventListener('change', (event) => {
								$('.tcustomizer-field--Dropdown').eq(event.target.getAttribute('data-index')).find('.tcustomizer__dropdown-item label').filter(`[for$=${event.target.value}]`).click();
							});
						});

						setTimeout(() => {
							form.querySelectorAll('.tcustomizer-field--Dropdown .tcustomizer__dropdown-select').forEach(function(select, index){
								const fakeSelect = form.querySelectorAll('.size-selectors .quantity-break__selector-item')[index].querySelector('select');
								const fakeSelectOptions = [];

								select.parentElement.querySelectorAll('input[type=radio]').forEach(function(input){
									fakeSelectOptions.push(`<option>${input.getAttribute('value')}</option>`);
								});

								fakeSelect.innerHTML = fakeSelectOptions.join('');
								fakeSelect.value = select.innerText.split(' ')[0];
							});

							// $('.tcustomizer-field--Dropdown .tcustomizer__dropdown-select').each(function(index){
							//     $('.size-selectors .quantity-break__selector-item').eq(index).find('select').val($(this).text().split(' ')[0]);
							// });
						});
					}
				}
			});
		};

		radioControlElements.forEach((element) => {
			const label = element.querySelector('label');
			const addon = element.querySelector('.tcustomizer-addon');

			element.classList.add('quantity-break');

			if (addon) {
				const priceInfo = document.createElement('div');
				const addonText = addon.innerText.trim();
				const addonValue = addonText === '' ? 0 : (parseFloat(addonText.replace(/\D/g,'')) * (_TC.moneyFormat.includes('no_decimals') ? 100 : 1));

				let mainAddonValue = 0;
				if (_TC.manualOption?.fields?.length && _TC.manualOption.fields[0].label === 'Choose Your Set:') {
					mainAddonValue = parseFloat(_TC.manualOption.fields[0].options[0].addon_rule.variant.price) * 100 * Shopify.currency.rate;
				}

				let fiveBucksAddon = 0;
				let fiveBucksTarget = document.querySelector('#tcustomizer-field-383146-7542354772054 .tcustomizer-col.quantity-break.is-checked input');
				if (fiveBucksTarget && fiveBucksTarget.value.toLowerCase().includes('liquid')) {
					fiveBucksAddon = 500 * Shopify.currency.rate;
				}

				priceInfo.className = 'price-info';
				priceInfo.innerHTML = `${convertPrice(window.mainProduct.price + mainAddonValue + addonValue + fiveBucksAddon)} ${window.mainProduct.compare_at_price > window.mainProduct.price ? `<em>${convertPrice(window.mainProduct.compare_at_price + mainAddonValue + addonValue)}</em>` : ''}`;

				addon.after(priceInfo);
			}

			element.addEventListener('click', function(){
				label.click();
				evaluateCheckedRadio();
			});

			evaluateCheckedRadio();
		});

		radioControl.classList.add('is-active');
		radioControl.classList.add('quantity-breaks--compact');
	}
	reStyleRadioElement();

	setTimeout(() => {
		document.querySelector('#tcustomizer-add').addEventListener('click', () => {
			setTimeout(() => {
				reStyleRadioElement();
			}, 200);
		});
	}, 500);

	// RadioButton
	function customizeRadioButtons() {
		form.querySelectorAll('.tcustomizer-field--RadioButton').forEach((radioButtonControl) => {
			if (!radioButtonControl.classList.contains('is-custom')) {
				radioButtonControl.classList.add('is-custom');

				const radioButtonControlElements = radioButtonControl.querySelectorAll('.tcustomizer-col');
				radioButtonControl.classList.add('quantity-breaks');
				radioButtonControl.classList.add('quantity-breaks--compact');
				radioButtonControl.querySelector('.tcustomizer-row').classList.add('quantity-breaks-container');

				const evaluateCheckedRadioButton = () => {
					radioButtonControlElements.forEach((element) => {
						const btn = element.querySelector('.tcustomizer-btn');

						if (!btn) {
							return;
						}

						element.classList.remove('is-checked');
						btn.classList.remove('tcustomizer-btn');

						if (btn.classList.contains('tcustomizer-btn--active')) {
							element.classList.add('is-checked');
						}
					});
				};

				radioButtonControlElements.forEach((element) => {
					const label = element.querySelector('label');

					element.classList.add('quantity-break');

					element.addEventListener('click', function(){
						label.click();
						evaluateCheckedRadioButton();
						customizeRadioButtons();

						setTimeout(() => {
							reStyleLabels();
							reStyleRadioElement();
							customizeRadioButtons();
							evaluateCheckedRadioButton();
						});
					});

					evaluateCheckedRadioButton();
				});
			}
		});
	}
	customizeRadioButtons();

	// AB Test (1)
	document.querySelectorAll('#tcustomizer-form-container-7707527479382').forEach((container) => {
		const checkIfBogo = () => {
			const oneFace = document.querySelector('[name=tcustomizer-form-field-87797-7707527479382][value="1 Face"]');
			const oneDrawing = document.querySelector('[name=tcustomizer-form-field-997287-7707527479382][value="1 Drawing"]');

			setTimeout(() => {
				const selection = container.querySelector('.tcustomizer-col.quantity-break.is-checked .tcustomizer__btn-check');

				if (selection && selection.id.includes('BOGO:')) {
					container.classList.add('is-bogo-selected');

					if (oneFace && oneFace.checked) {
						document.querySelector('[name=tcustomizer-form-field-87797-7707527479382][value="2 Faces"]').click();
					} else if (oneDrawing && oneDrawing.checked) {
						document.querySelector('[name=tcustomizer-form-field-997287-7707527479382][value="2 Drawings"]').click();
					}
				} else {
					container.classList.remove('is-bogo-selected');
				}
			});
		}

		checkIfBogo();

		container.addEventListener('click', (event) => {
			checkIfBogo();

			const mainTarget = event.target.closest('.tcustomizer-radio.quantity-break');
			if (mainTarget === mainTarget.parentElement.firstElementChild) {
				if (document.querySelector('.is-bogo-selected')) {
					event.preventDefault();
				}
			}
		});
	});

	// AB Test (2)
	document.querySelectorAll('#tcustomizer-form-container-7707529216086').forEach((container) => {
		const target = container.querySelector('.tcustomizer-customization-form');
		target.classList.add('is-ab-test2');

		target.querySelectorAll('#tcustomizer-field-1006-7707529216086 .tcustomizer-col.quantity-break:first-child').forEach((option) => {
			const newPrice = document.createElement('div');
			newPrice.textContent = '$29.99';
			newPrice.classList.add('ab-test-new-price');
			option.append(newPrice);

			const oldPrice = document.createElement('div');
			oldPrice.textContent = '$49.99';
			oldPrice.classList.add('ab-test-old-price');
			option.append(oldPrice);
		});

		target.querySelectorAll('#tcustomizer-field-1006-7707529216086 .tcustomizer-col.quantity-break:last-child').forEach((option) => {
			const savings = document.createElement('div');
			savings.textContent = 'You save $69.99';
			savings.classList.add('ab-test-savings');
			option.append(savings);

			const newPrice = document.createElement('div');
			newPrice.textContent = '$29.99';
			newPrice.classList.add('ab-test-new-price');
			option.append(newPrice);

			const oldPrice = document.createElement('div');
			oldPrice.textContent = '$99.99';
			oldPrice.classList.add('ab-test-old-price');
			option.append(oldPrice);
		});

		const checkIfBogo = () => {
			const oneFace = document.querySelector('[name=tcustomizer-form-field-87797-7707529216086][value="1 Face"]');
			const oneDrawing = document.querySelector('[name=tcustomizer-form-field-997287-7707529216086][value="1 Drawing"]');

			setTimeout(() => {
				const selection = container.querySelector('.tcustomizer-col.quantity-break.is-checked .tcustomizer__btn-check');

				if (selection && selection.id.includes('2 Cases')) {
					container.classList.remove('is-bo-selected');
					container.classList.add('is-bogo-selected');

					if (oneFace && oneFace.checked) {
						document.querySelector('[name=tcustomizer-form-field-87797-7707529216086][value="2 Faces"]').click();
					} else if (oneDrawing && oneDrawing.checked) {
						document.querySelector('[name=tcustomizer-form-field-997287-7707529216086][value="2 Drawings"]').click();
					}
				} else if (selection && selection.id.includes('1 Case')) {
					container.classList.add('is-bo-selected');
					container.classList.remove('is-bogo-selected');
				} else {
					container.classList.remove('is-bo-selected');
					container.classList.remove('is-bogo-selected');
				}
			});
		}

		checkIfBogo();

		container.addEventListener('click', (event) => {
			checkIfBogo();

			const mainTarget = event.target.closest('.tcustomizer-radio.quantity-break');
			if (mainTarget === mainTarget.parentElement.firstElementChild) {
				if (document.querySelector('.is-bogo-selected')) {
					event.preventDefault();
				}
			}
		});
	});

	// AB Test (3)
	document.querySelectorAll('#tcustomizer-form-container-7707530723414, #tcustomizer-form-container-7765531656278').forEach((container) => {
		container.addEventListener('click', (event) => {
			const mainTarget = event.target.closest('.tcustomizer-col.quantity-break');
			const mainTargetText = mainTarget.innerText.trim().toLowerCase();
			if (mainTargetText.includes('air') && mainTargetText.includes('case')) {
				event.preventDefault();
				event.stopPropagation();
				document.querySelector('.tcustomizer-col.quantity-break:nth-child(2)').click();
				window.location.href = 'https://shakercase.com/products/shakercase-with-shaking-custom-charms';
			}
		});
	});

	// AB Test (4)
	document.querySelectorAll('#tcustomizer-form-container-7635866714198').forEach((container) => {
		const airCaseInput = container.querySelector('#tcustomizer-field-225123-7635866714198 .tcustomizer-col:first-child input[type=radio]');

		if (airCaseInput) {
			airCaseInput.checked = true;
			airCaseInput.nextElementSibling.classList.add('tcustomizer-btn--active');
			airCaseInput.parentElement.classList.add('is-checked');
		}

		container.addEventListener('click', (event) => {
			const mainTarget = event.target.closest('.tcustomizer-col.quantity-break');
			const mainTargetText = mainTarget.innerText.trim().toLowerCase();
			if (mainTargetText.includes('liquid') && mainTargetText.includes('case')) {
				event.preventDefault();
				event.stopPropagation();
				document.querySelector('.tcustomizer-col.quantity-break:first-child').click();
				window.location.href = 'https://shakercase.com/products/shaker-case%E2%84%A2-liquid-with-custom-charms';
			} else if (mainTargetText.includes('air') && mainTargetText.includes('case')) {
				event.preventDefault();
				event.stopPropagation();
				setTimeout(() => {
					document.querySelector('#tcustomizer-field-225123-7635866714198 .tcustomizer-col.quantity-break').classList.add('is-checked');
				});
			}
		});
	});
});
